<div
  class="app-layout"
  *ngIf="isLoggedIn"
  [class.navOpen]="isNavOpen"
  [class.app-help-layout]="isHelp"
  [class]="isLoading ? 'loader-overlay loading' : ''">
  <header class="app-header" *ngIf="!isHelp">
    <div class="nav-toggle">
      <a
        href="javascript:void(0)"
        (click)="navToggle()"
        class="btn btn-md btn-icon"
        *ngIf="!isHelp">
        <i class="icon-{{ isNavOpen ? 'close-c' : 'menu-c' }}" style="font-size: 19px"></i>
      </a>
    </div>
    <div class="logo m0 mr45">
      <a href="/">
        <img src="assets/images/bombardier-ssics-logo-black.svg" alt="" />
      </a>
    </div>
    <div></div>
  </header>

  <header class="app-header" *ngIf="isHelp">
    <div class="logo">
      <a href="/">
        <img src="assets/images/bombardier-ssics-logo-black.svg" alt="" />
      </a>
    </div>
    <h1>
      <ng-container>
        {{ 'help.help' | translate }}
      </ng-container>
    </h1>
    <div class="pr10">
      <a
        *ngIf="!isHelp"
        href="javascript:void(0)"
        class="simple-btn-md simple-btn-icon"
        title="{{ 'help.help' | translate }}"
        (click)="onOpenHelpInNewTab()"
        ><i class="icon-help-1"></i
      ></a>
      <dx-drop-down-button
        #userMenu
        [icon]="userPhotoUrl ? userPhotoUrl : ''"
        [text]="fullName"
        [deferRendering]="false"
        [useSelectMode]="false"
        [showArrowIcon]="false"
        stylingMode="text"
        dropDownContentTemplate="contentTemplate"
        [dropDownOptions]="{ width: 230 }">
        <div *dxTemplate="let field of 'item'">
          <a
            href="javascript:void(0)"
            class="user user-md"
            [title]="fullName"
            (click)="$event.stopPropagation(); userMenu.opened = !userMenu.opened">
            <span class="name">{{ fullName }} </span>
            <b
              class="user-photo"
              [ngStyle]="{
                'background-image':
                  'url(' + (portalUser?.photoFileUri ? portalUser?.photoFileUri : '') + ')',
              }"
              >{{ !portalUser?.photoFileUri ? getUserShortName() : '' }}</b
            >
            <i class="icon-angle-down text-medium fs20"></i>
          </a>
        </div>
        <div *dxTemplate="let item of 'contentTemplate'">
          <ul class="dropdown-menu" (click)="userMenu.opened = false">
            <li>
              <a href="javascript:void(0)" (click)="onSignOutClick()">{{
                'general.logout' | translate
              }}</a>
            </li>
          </ul>
        </div>
      </dx-drop-down-button>
    </div>
  </header>

  <nav class="app-nav" *ngIf="!isHelp">
    <div class="wrapper">
      <div class="top">
        <div class="logo">
          <a href="/">
            <img src="assets/images/bombardier-ssics-logo-white.svg" width="100" alt="" />
          </a>
        </div>
        <ul>
          <li class="main-menu" *ngFor="let menu of sysSecuredMenus">
            <a routerLink="{{ menu.route }}" class="menu-item" *ngIf="menu.isActive">
              <i class="{{ menu.icon }}"></i>
              <span>{{ menu.nameEn }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="bottom">
        <ul class="mb10">
          <li class="main-menu">
            <a
              href="javascript:void(0)"
              class="menu-item"
              *ngIf="refExternalResourceExpFlag"
              (click)="onExternalResExpList()"
              ><i class="icon-history-1 icon-flipped icon-danger"></i>
              <span>{{ 'general.upcomingExpirations' | translate }}</span></a
            >
            <a href="javascript:void(0)" class="menu-item" (click)="onOpenHelpInNewTab()"
              ><i class="icon-help-1"></i> <span>{{ 'help.help' | translate }}</span></a
            >
            <a href="javascript:void(0)" class="menu-item" (click)="onSignOutClick()"
              ><i class="icon-out"></i>
              <span class="d-block" style="line-height: 1.3">
                <div>{{ 'general.logout' | translate }}</div>
                <div class="text-medium text-ellipsis fs14">{{ fullName }}</div>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="app-content">
    <router-outlet (activate)="onRouteActivate()"></router-outlet>
  </div>
  <div class="nav-shade-mobile" (click)="navToggle()"></div>
</div>

<div class="h100" *ngIf="!isLoggedIn">
  <app-login></app-login>
</div>

<shared-popup
  *ngIf="displayIdleConfirmDialog"
  [visible]="displayIdleConfirmDialog"
  [panelClass]="'popup w600'"
  [animation]="'scale'"
  [outsideClick]="false">
  <div *appPopupTemplate>
    <div class="app-modal app-modal-simple">
      <div class="app-modal-header p15">
        <h1 class="acenter">
          {{ 'userIdle.user_idle_message_title' | translate }}
        </h1>
      </div>
      <div class="app-modal-content acenter">
        <div class="app-form-panel app-form-panel-simple">
          <div class="app-form-panel-content">
            <div class="horizontal-splitter">
              <i class="icon-exclamation_line text-warning fs24 vam"></i>
              {{ 'userIdle.user_idle_message_content' | translate }}
            </div>
            <div class="pt30">
              <div>
                {{ 'userIdle.user_idle_message_time_left' | translate }}
              </div>
              <span class="fs30 fw500">{{
                moment
                  .utc(
                    moment
                      .duration(idleTimeOutLimit, 'seconds')
                      .subtract(userSecondsIdle, 'seconds')
                      .asMilliseconds()
                  )
                  .format('mm:ss')
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="app-modal-footer">
        <div class="buttons-wrapper">
          <a
            href="javascript:void(0)"
            (click)="endIdleTimerAndSession()"
            class="simple-btn simple-btn-rounded simple-btn-text-grey simple-btn-md bigger-side-pads">
            {{ 'general.logout' | translate }}
          </a>
          <a
            href="javascript:void(0)"
            (click)="restartIdleTimer()"
            class="simple-btn simple-btn-rounded simple-btn-primary simple-btn-md bigger-side-pads">
            {{ 'actions.continue' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</shared-popup>

<shared-popup
  *ngIf="isExternalResExpPopup"
  [(visible)]="isExternalResExpPopup"
  [panelClass]="'popup small'"
  [animation]="'scale'"
  [outsideClick]="false">
  <div *appPopupTemplate>
    <div class="app-modal app-modal-simple">
      <div class="app-modal-header">
        <h1>
          <div>{{ popupHeading }}</div>
        </h1>
        <a href="javascript:void(0)" class="app-modal-close-icon" (click)="closeEditMode()"> </a>
      </div>
      <div class="app-modal-content app-modal-content-advanced summary-container">
        <dx-scroll-view showScrollbar="always">
          <app-upcoming-expiration
            [refExternalResourceExp]="refExternalResourceExp"></app-upcoming-expiration>
        </dx-scroll-view>
      </div>
      <div class="app-modal-footer aright">
        <a
          href="javascript:void(0)"
          (click)="closeEditMode()"
          class="simple-btn simple-btn-rounded simple-btn-text-grey simple-btn-md bigger-side-pads">
          {{ 'general.close' | translate }}
        </a>
      </div>
    </div>
  </div>
</shared-popup>

<shared-popup
  [(visible)]="showRefreshPopup"
  [panelClass]="'popup small'"
  [animation]="'scale'"
  [outsideClick]="false">
  <div class="app-modal app-modal-simple new-version-popup">
    <div class="app-modal-content">
      <div class="app-form-panel app-form-panel-simple">
        <div class="app-form-panel-content acenter">
          <div>
            <img
              src="../../../../../assets/images/icon-lightbulb.svg"
              alt=""
              style="width: 170px" />
          </div>
          <h1>
            {{ 'general.newVersionAvailable' | translate }}
          </h1>
          <div class="fs15">
            {{ 'general.newVersionRefreshText' | translate }}
          </div>
          <div class="mt40">
            <a
              href="javascript:void(0)"
              class="simple-btn simple-btn-rounded simple-btn-primary simple-btn-md bigger-side-pads"
              (click)="updateToLatest()">
              {{ 'actions.refresh' | translate }}
            </a>
            <a
              href="javascript:void(0)"
              class="simple-btn simple-btn-rounded simple-btn-text-grey simple-btn-md bigger-side-pads"
              (click)="showRefreshPopup = false">
              {{ 'actions.cancel' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</shared-popup>
